module.exports = __webpack_public_path__ + "img/rubber-ring.432a74ba.svg";